import { parseAsArrayOf, parseAsString, useQueryStates } from 'nuqs'

// Define all filter parsers - align with useInvoiceQuery expected parameters
const containerFilterParsers = {
  // Search query
  search: parseAsString.withDefault('').withOptions({
    clearOnDefault: true,
  }),

  // Status filters
  status: parseAsArrayOf(parseAsString, ',').withDefault(['all']).withOptions({
    clearOnDefault: true,
  }),
}

export function useContainerFilters() {
  const [filters, setFilters] = useQueryStates(containerFilterParsers, {
    history: 'replace', // Use replace to avoid cluttering browser history
    shallow: true, // Client-side only updates
  })

  // Helper functions for easier state management
  const updateSearch = (search: string) => {
    setFilters((prev) => ({ ...prev, search }))
  }

  const updateStatus = (statuses: string[]) => {
    setFilters((prev) => ({ ...prev, status: statuses }))
  }

  const clearAllFilters = () => {
    // Clear all filters in a single atomic operation to prevent step-by-step clearing
    setFilters({
      search: '',
      status: ['all'],
    })
  }

  // Check if any filters are active (excluding defaults)
  const hasActiveFilters =
    filters.search !== '' || !filters.status.includes('all')

  return {
    // Current filter values
    filters,

    // Update functions
    updateSearch,
    updateStatus,
    setFilters,
    clearAllFilters,

    // Helper states
    hasActiveFilters,
  }
}

// Type exports for better TypeScript support
export type ContainerFilters = ReturnType<typeof useContainerFilters>['filters']
export type ContainerFilterKey = keyof typeof containerFilterParsers
